// @flow

import { createSelector } from 'reselect'
import { propOr } from 'ramda'

import type { DebugState } from './reducers'

type DebugStore = { debug: DebugState }

export const getDebug = (state: DebugStore): DebugState => state.debug

export const getIsDebugEnabled: any = createSelector([getDebug], (debug: DebugState): boolean =>
  propOr(false, 'enabled', debug),
)

export const getIsDebugUnlocked: any = createSelector([getDebug], (debug: DebugState): boolean =>
  propOr(false, 'unlocked', debug),
)
